// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.submission-view-page {
  max-width: 1180px;
  margin: 0 auto;
  padding: 2.5rem 1.5rem 3rem;
}

.submission-header h1 {
  margin: 0.35rem 0 0.25rem;
  font-size: 2rem;
}

.submission-eyebrow {
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #5b6471;
  font-weight: 700;
  font-size: 0.75rem;
  margin: 0;
}

.submission-subtext {
  margin: 0.35rem 0 1rem;
  color: #4a5568;
}

.submission-layout {
  display: grid;
  grid-template-columns: 1.1fr 0.9fr;
  gap: 1.5rem;
  align-items: start;
}

.submission-readonly .step-container .description-box,
.submission-readonly .step-container .trace-var-name-input,
.submission-readonly .step-container .trace-var-input {
  pointer-events: none;
}

.submission-readonly .run-button,
.submission-readonly .ide-inline-submit-btn {
  opacity: 0.7;
  cursor: not-allowed;
}

.submission-code-only .ide-only-shell {
  height: calc(100vh - 220px);
  min-height: 520px;
  border: 1px solid #dce3ed;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.1);
}

.code-view-card {
  background: #fff;
  border: 1px solid #dce3ed;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.12);
  color: #1f2937;
}

.code-view-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.25rem;
  border-bottom: 1px solid #dce3ed;
  background: #f8fbff;
}

.code-view-card-header h2 {
  margin: 0.25rem 0 0;
  color: #0f172a;
}

.code-view-editor {
  padding: 1rem 1.25rem 1.5rem;
}

.code-view-editor .cm-editor {
  border: 1px solid #dce3ed;
  border-radius: 10px;
  overflow: hidden;
}

.submission-steps-card {
  background: #fff;
  border: 1px solid #dce3ed;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.1);
}

.submission-steps-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.25rem;
  border-bottom: 1px solid #dce3ed;
}

.submission-step-card {
  overflow: hidden;
}

.submission-step-head {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1rem 0.25rem;
}

.submission-step-label {
  font-weight: 700;
  color: #222;
}

.submission-pill {
  display: inline-flex;
  align-items: center;
  padding: 0.2rem 0.55rem;
  border-radius: 999px;
  background: #e8edff;
  color: #1f3b8f;
  font-size: 0.78rem;
  font-weight: 700;
}

.submission-pill.muted {
  background: #f1f5f9;
  color: #475569;
  margin-top: 0.75rem;
}

.submission-trace-block {
  padding: 0 1rem 1rem;
}

.submission-empty-trace {
  padding: 0 1rem 1rem;
  color: #6b7280;
  margin: 0;
}

.submission-empty-card {
  padding: 1.25rem 1.5rem;
  border: 1px dashed #cbd5e1;
  border-radius: 10px;
  background: #f8fafc;
  color: #334155;
}

.submission-muted {
  color: #6b7280;
  margin: 0.25rem 0 0;
}

.submission-steps-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.submission-problem-card {
  margin: 1.25rem 0 1.75rem;
  padding: 1.1rem 1.25rem;
  border: 1px solid #dce3ed;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.04);
}

.submission-problem-card pre {
  white-space: pre-wrap;
  line-height: 1.5;
  color: #1f2937;
  margin: 0.6rem 0 0.4rem;
}

.submission-steps-shell {
  background: #fff;
  border: 1px solid #dce3ed;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08);
}

@media (max-width: 1080px) {
  .submission-layout {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 640px) {
  .submission-view-page {
    padding: 1.5rem 1.1rem 2rem;
  }

  .code-view-card-header,
  .submission-steps-card-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.35rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/SubmissionView.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,WAAW;EACX,kBAAkB;AACpB;;AAEA;;;EAGE,oBAAoB;AACtB;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,6CAA6C;EAC7C,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;EACrB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;;IAEE,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;EACd;AACF","sourcesContent":[".submission-view-page {\n  max-width: 1180px;\n  margin: 0 auto;\n  padding: 2.5rem 1.5rem 3rem;\n}\n\n.submission-header h1 {\n  margin: 0.35rem 0 0.25rem;\n  font-size: 2rem;\n}\n\n.submission-eyebrow {\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  color: #5b6471;\n  font-weight: 700;\n  font-size: 0.75rem;\n  margin: 0;\n}\n\n.submission-subtext {\n  margin: 0.35rem 0 1rem;\n  color: #4a5568;\n}\n\n.submission-layout {\n  display: grid;\n  grid-template-columns: 1.1fr 0.9fr;\n  gap: 1.5rem;\n  align-items: start;\n}\n\n.submission-readonly .step-container .description-box,\n.submission-readonly .step-container .trace-var-name-input,\n.submission-readonly .step-container .trace-var-input {\n  pointer-events: none;\n}\n\n.submission-readonly .run-button,\n.submission-readonly .ide-inline-submit-btn {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n.submission-code-only .ide-only-shell {\n  height: calc(100vh - 220px);\n  min-height: 520px;\n  border: 1px solid #dce3ed;\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.1);\n}\n\n.code-view-card {\n  background: #fff;\n  border: 1px solid #dce3ed;\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.12);\n  color: #1f2937;\n}\n\n.code-view-card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1rem 1.25rem;\n  border-bottom: 1px solid #dce3ed;\n  background: #f8fbff;\n}\n\n.code-view-card-header h2 {\n  margin: 0.25rem 0 0;\n  color: #0f172a;\n}\n\n.code-view-editor {\n  padding: 1rem 1.25rem 1.5rem;\n}\n\n.code-view-editor .cm-editor {\n  border: 1px solid #dce3ed;\n  border-radius: 10px;\n  overflow: hidden;\n}\n\n.submission-steps-card {\n  background: #fff;\n  border: 1px solid #dce3ed;\n  border-radius: 12px;\n  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.1);\n}\n\n.submission-steps-card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1rem 1.25rem;\n  border-bottom: 1px solid #dce3ed;\n}\n\n.submission-step-card {\n  overflow: hidden;\n}\n\n.submission-step-head {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.75rem 1rem 0.25rem;\n}\n\n.submission-step-label {\n  font-weight: 700;\n  color: #222;\n}\n\n.submission-pill {\n  display: inline-flex;\n  align-items: center;\n  padding: 0.2rem 0.55rem;\n  border-radius: 999px;\n  background: #e8edff;\n  color: #1f3b8f;\n  font-size: 0.78rem;\n  font-weight: 700;\n}\n\n.submission-pill.muted {\n  background: #f1f5f9;\n  color: #475569;\n  margin-top: 0.75rem;\n}\n\n.submission-trace-block {\n  padding: 0 1rem 1rem;\n}\n\n.submission-empty-trace {\n  padding: 0 1rem 1rem;\n  color: #6b7280;\n  margin: 0;\n}\n\n.submission-empty-card {\n  padding: 1.25rem 1.5rem;\n  border: 1px dashed #cbd5e1;\n  border-radius: 10px;\n  background: #f8fafc;\n  color: #334155;\n}\n\n.submission-muted {\n  color: #6b7280;\n  margin: 0.25rem 0 0;\n}\n\n.submission-steps-list {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.submission-problem-card {\n  margin: 1.25rem 0 1.75rem;\n  padding: 1.1rem 1.25rem;\n  border: 1px solid #dce3ed;\n  border-radius: 12px;\n  background: #fff;\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.04);\n}\n\n.submission-problem-card pre {\n  white-space: pre-wrap;\n  line-height: 1.5;\n  color: #1f2937;\n  margin: 0.6rem 0 0.4rem;\n}\n\n.submission-steps-shell {\n  background: #fff;\n  border: 1px solid #dce3ed;\n  border-radius: 12px;\n  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08);\n}\n\n@media (max-width: 1080px) {\n  .submission-layout {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 640px) {\n  .submission-view-page {\n    padding: 1.5rem 1.1rem 2rem;\n  }\n\n  .code-view-card-header,\n  .submission-steps-card-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.35rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
